export class Campaign {
  /**
   *
   */
  public campaignId: number;

  /**
   *
   */
  public campaignName: string;

  /**
   *
   */
  public availableForDefects: boolean;

  /**
   * Creates an instance of Campaign.
   *
   * @param campaignId the campaign id
   * @param campaignName the campaign name
   * @param availableForDefects the available for defects state
   */
  public constructor(campaignId = 0, campaignName = '', availableForDefects = false) {
    this.campaignId = campaignId;
    this.campaignName = campaignName;
    this.availableForDefects = availableForDefects;
  }
}
